import { getMonth, getYear } from "date-fns";
import { useFormikContext } from "formik";
import { FC, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { allYears, months, years } from "./utils";

import { Box, Flex, FormErrorMessage, Text } from "@chakra-ui/react";

import { IDatepicker } from "./types";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerComponent: FC<IDatepicker> = ({
  label,
  handleChange,
  isError,
  id,
  value: val,
  handleBlur,
  leftComponent,
  name,
  placeholder,
  poperPosition,
  isEvent,
  minTime,
  maxTime,
  updateNullVal,
  useAllYears = false,
  ...props
}) => {
  const [startDate, setStartDate] = useState(val);

  useEffect(() => {
    if (!updateNullVal) {
      if (val) {
        setStartDate(val);
      }
    } else {
      setStartDate(val);
    }
  }, [val]);

  const yearsToUse = useAllYears ? allYears : years;

  return (
    <Box w="full" zIndex={2}>
      {label && (
        <Text fontSize={"16px"} lineHeight="120%" fontWeight={600} mb="12px">
          {label}
        </Text>
      )}
      <Flex
        w="100%"
        h={"48px"}
        bg="white"
        borderRadius="7px"
        border="1px solid rgb(208, 208, 208)"
        position="relative"
        alignItems="center"
      >
        {leftComponent && (
          <Flex
            position="absolute"
            justifyContent="center"
            alignItems="center"
            w="40px"
            h="100%"
            left="0"
            zIndex={2}
          >
            {leftComponent}
          </Flex>
        )}
        <DatePicker
          dateFormat="yyyy-MM-dd"
          placeholderText={placeholder}
          {...props}
          onBlur={handleBlur}
          minTime={minTime}
          maxTime={maxTime}
          className={`datepicker ${leftComponent ? `datepicker_left` : ``} `}
          renderCustomHeader={({ date, changeYear, changeMonth }) => (
            <div
              style={{
                margin: 10,
                display: "flex",
                justifyContent: "center",
                columnGap: "12px",
              }}
            >
              <select
                value={getYear(date)}
                onChange={({ target: { value } }) =>
                  changeYear(parseInt(value))
                }
                style={{
                  flex: 1,
                  border: "1px solid #E5E8F0",
                  borderRadius: "8px",
                  height: "30px",
                  paddingLeft: "10px",
                }}
              >
                {yearsToUse.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>

              <select
                value={months[getMonth(date)]}
                onChange={({ target: { value } }) =>
                  changeMonth(months.indexOf(value))
                }
                style={{
                  flex: 1,
                  border: "1px solid #E5E8F0",
                  borderRadius: "8px",
                  height: "30px",
                  paddingLeft: "10px",
                }}
              >
                {months.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>
          )}
          selected={startDate}
          onChange={(date) => {
            setStartDate(date);
            handleChange(date);
          }}
          popperPlacement={poperPosition ?? "bottom-start"}
        />
      </Flex>

      {isError && (
        <FormErrorMessage>{`isError || ${id} is required`}</FormErrorMessage>
      )}
    </Box>
  );
};

export const DatePickerInput: FC<
  IDatepicker & {
    name: string;
    handleBlur?: (e: React.FocusEvent<any, Element>) => void;
  }
> = ({ name, poperPosition, ...rest }) => {
  const { values, errors, touched, getFieldProps } = useFormikContext();
  const hasError =
    (errors as any)[name] && (touched as any)[name] && (errors as any)[name];

  return (
    <DatePickerComponent
      {...rest}
      name={name}
      value={(values as any)[name as any] || getFieldProps(name)?.value}
      isError={hasError}
      poperPosition={poperPosition}
    />
  );
};

export default DatePickerComponent;
